// @tennis-matches/services/governance
// PostgREST: prefer public RPC wrappers; fallback to app_config schema when exposed.

import { isAppConfigSchemaUnavailableError, isRestEndpointUnavailable, markRestEndpointUnavailable, APP_CONFIG_SCHEMA_REST_KEY } from "../supabase/rest-endpoint-availability.js";

const SCHEMA = "app_config";

function __db(supabase) {
  return supabase && typeof supabase.schema === "function" ? supabase.schema(SCHEMA) : supabase;
}

/**
 * @param {import("@supabase/supabase-js").SupabaseClient} supabase
 * @param {string} rpcName
 * @param {Record<string, unknown>} [payload]
 */
export async function callGovernanceRpc(supabase, rpcName, payload = {}) {
  const publicRes = await supabase.rpc(rpcName, payload);
  if (!publicRes?.error || !isAppConfigSchemaUnavailableError(publicRes.error)) {
    return publicRes;
  }

  if (isRestEndpointUnavailable(APP_CONFIG_SCHEMA_REST_KEY)) {
    return publicRes;
  }

  const db = __db(supabase);
  if (!db) return publicRes;
  const schemaRes = await db.rpc(rpcName, payload);
  if (schemaRes?.error && isAppConfigSchemaUnavailableError(schemaRes.error)) {
    markRestEndpointUnavailable(APP_CONFIG_SCHEMA_REST_KEY);
  }
  return schemaRes;
}
